<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 颠覆式设计系统：深色侧栏 + 高对比内容区，参考 Linear / Vercel / Stripe */
:root {
  /* 侧栏（深色） */
  --side-bg: #0c0c0f;
  --side-text: #e4e4e7;
  --side-text-dim: #71717a;
  --side-hover: rgba(255, 255, 255, 0.06);
  --side-active: rgba(255, 255, 255, 0.1);
  --side-border: rgba(255, 255, 255, 0.06);
  
  /* 主内容区（亮） */
  --surface: #fafafa;
  --surface-card: #ffffff;
  --ink: #18181b;
  --ink-secondary: #52525b;
  --ink-muted: #a1a1aa;
  --border: rgba(0, 0, 0, 0.08);
  --border-strong: rgba(0, 0, 0, 0.12);
  
  /* 强调色：一抹亮色 */
  --accent: #f43f5e;
  --accent-hover: #e11d48;
  --accent-soft: rgba(244, 63, 94, 0.12);
  --secondary: #06b6d4;
  --secondary-light: rgba(6, 182, 212, 0.25);
  --success: #22c55e;
  --danger: #ef4444;
  --warning: #f59e0b;
  
  --font-display: 'Outfit', 'Plus Jakarta Sans', sans-serif;
  --font-sans: 'Plus Jakarta Sans', -apple-system, sans-serif;
  --radius: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;
  --radius-full: 9999px;
  --shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 12px 40px rgba(0, 0, 0, 0.1);
  
  /* 兼容旧变量 */
  --primary-color: var(--accent);
  --primary-dark: var(--accent-hover);
  --primary-light: rgba(244, 63, 94, 0.2);
  --secondary-color: #06b6d4;
  --text-color: var(--ink);
  --text-secondary: var(--ink-secondary);
  --text-muted: var(--ink-muted);
  --bg-color: var(--surface);
  --card-bg: var(--surface-card);
  --border-color: var(--border);
  --danger-color: var(--danger);
  --border-radius-sm: var(--radius);
  --border-radius-md: var(--radius-lg);
  --border-radius-lg: var(--radius-xl);
  --border-radius-round: var(--radius-full);
  --shadow-sm: var(--shadow);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--surface);
  color: var(--ink);
  line-height: 1.6;
  font-size: 15px;
}

#app {
  width: 100%;
  min-height: 100vh;
}

button {
  font-family: inherit;
  outline: none;
  cursor: pointer;
}

::-webkit-scrollbar { width: 8px; height: 8px; }
::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
::-webkit-scrollbar-thumb { background: #d4d4d8; border-radius: 4px; }
::-webkit-scrollbar-thumb:hover { background: #a1a1aa; }

/* 深色侧栏内的滚动条 */
.sidebar ::-webkit-scrollbar-track { background: transparent; }
.sidebar ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); }
.sidebar ::-webkit-scrollbar-thumb:hover { background: rgba(255,255,255,0.25); }

.el-button--primary { background: var(--accent); border-color: var(--accent); }
.el-button--primary:hover, .el-button--primary:focus { background: var(--accent-hover); border-color: var(--accent-hover); }
.el-button--default:hover { color: var(--accent); border-color: var(--accent); background: var(--accent-soft); }
.el-input__inner { border-radius: var(--radius); }
.el-input__inner:focus { border-color: var(--accent); }
.el-dialog, .el-message-box { border-radius: var(--radius-lg); box-shadow: var(--shadow-lg); }
.el-pagination.is-background .el-pager li:not(.disabled).active { background: var(--accent); }
.el-loading-spinner .path { stroke: var(--accent); }
.el-loading-spinner .el-loading-text { color: var(--accent); }
</style>
